const types = {
    SET_LIST_GAME_FREESPIN: '[FREESPIN GAME] SET LIST GAME FREESPIN',
    SET_VIEW_GAME_FREESPIN: '[FREESPIN GAME] SET VIEW GAME FREESPIN'
}

export {
    types
}